import React, { useEffect } from 'react';
import { trackFunnelStep } from '../analytics';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Alert,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SubscriptionCancel = ({ onReturnToHome }) => {
  useEffect(() => {
    trackFunnelStep('checkout_cancelled');
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Card sx={{ textAlign: 'center', boxShadow: 3 }}>
          <CardContent sx={{ py: 6 }}>
            <CancelIcon
              sx={{
                fontSize: 80,
                color: 'warning.main',
                mb: 3,
              }}
            />
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                mb: 2,
                color: '#2c3e50',
              }}
            >
              Subscription Canceled
            </Typography>
            <Typography
              variant="body1"
              color="textSecondary"
              sx={{ mb: 4 }}
            >
              You've canceled the checkout process. No charges have been made to your account.
            </Typography>

            <Alert severity="info" sx={{ mb: 4, textAlign: 'left' }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Still interested?</strong>
              </Typography>
              <Typography variant="body2">
                You can start your free 7-day trial anytime. Your credit card is not charged until the end of the trial and you can cancel anytime.
              </Typography>
            </Alert>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Button
                variant="contained"
                size="large"
                onClick={onReturnToHome}
                startIcon={<ArrowBackIcon />}
                sx={{
                  textTransform: 'none',
                  fontSize: '1.1rem',
                  fontWeight: 700,
                  py: 1.5,
                }}
              >
                Return to Home
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={() => window.location.reload()}
                sx={{
                  textTransform: 'none',
                  fontSize: '1rem',
                  py: 1.5,
                }}
              >
                Try Again
              </Button>
            </Box>

            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ mt: 4 }}
            >
              Questions? Contact us at support@resellerprosoftware.com
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default SubscriptionCancel;
